import styled from "styled-components";

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #719430;
  max-width: 210px;
  cursor: pointer;

  @media (max-width: 768px) {
    max-width: none;
  }
  label {
    margin: 0;
    color: #719430;
    pointer-events: none;
  }
`;
const FilterInput = ({ filter, handleToggle, checkList }) => {
  return (
    <InputContainer onClick={() => handleToggle(filter.id)}>
      <label htmlFor={filter.value}>{filter.value}</label>
      <input
        type="checkbox"
        id={filter.value}
        checked={checkList.includes(filter.id)}
        readOnly
      />
    </InputContainer>
  );
};

export default FilterInput;
